import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Navigation } from 'app/core/navigation/navigation.types';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {
  private _httpClient: HttpClient = inject(HttpClient);

  get(): Observable<Navigation> {
    return this._httpClient.get<Navigation>('api/common/navigation');
  }
}
